import mock from "../utils/mock";

const profile = [
  {
    apName: "AP 1",
    apCategory: "category 1",
  },
  {
    apName: "AP 2",
    apCategory: "category 2",
  },
];

const names = [
  { id: 1, name: "Bakery" },
  { id: 2, name: "Grocery" },
  { id: 3, name: "Electronics" },
  { id: 4, name: "Clothing" },
  { id: 5, name: "Furniture" },
  { id: 6, name: "Pharmacy" },
  { id: 7, name: "Restaurant" },
  { id: 8, name: "Jewelry" },
  { id: 9, name: "Toy Store" },
  { id: 10, name: "Bookstore" },
];

mock.onGet("/api/social").reply(() => {
  return [200, profile];
});

mock.onGet("/api/adCategories").reply(() => {
  return [200, names];
});
